import { render, staticRenderFns } from "./EscalaTroca.vue?vue&type=template&id=160d5ec6&"
import script from "./EscalaTroca.vue?vue&type=script&lang=js&"
export * from "./EscalaTroca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports